import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { deleteSession, stopWatchingForOtherTabSessionChange } from "@insite/client-framework/Services/SessionService";

type HandlerType = Handler;

export const DeleteSession: HandlerType = () => {
    stopWatchingForOtherTabSessionChange(); // Prevent reload caused by this sign-out, which could interfere with the RedirectToHomePage step.
    return deleteSession();
};

export const chain = [DeleteSession];

const supplyLandGuestSignOut = createHandlerChainRunnerOptionalParameter(chain, {}, "SupplyLandGuestSignOut");
export default supplyLandGuestSignOut;
